import { render, staticRenderFns } from "./PreviewPoll.vue?vue&type=template&id=61b0fd69&scoped=true"
import script from "./PreviewPoll.vue?vue&type=script&lang=js"
export * from "./PreviewPoll.vue?vue&type=script&lang=js"
import style0 from "./PreviewPoll.vue?vue&type=style&index=0&id=61b0fd69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b0fd69",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAppBar,VBtn,VCard,VCheckbox,VImg,VTextField})
